module.exports = __webpack_public_path__ + "img/icon-21.decc133b.svg";